import { useState } from "react";
import { Package, Wallet } from "lucide-react";
import { WithdrawalsTab } from "@/components/WithdrawalsTab";
import { PaymentsAdminTab } from "@/components/PaymentsAdminTab";

export function RetirosPanel({ canViewMerch, canConfirmMerch, canViewCash, canConfirmCash }) {
  const subs = [
    canViewMerch && ["mercancia", "Mercancía", Package],
    canViewCash && ["dinero", "Dinero", Wallet],
  ].filter(Boolean);
  const [sub, setSub] = useState(subs[0]?.[0] || "mercancia");
  return (
    <div data-testid="retiros-panel">
      {subs.length > 1 && (
        <div className="flex gap-2 mb-5" data-testid="retiros-subtabs">
          {subs.map(([k, l, Icon]) => (
            <button key={k} data-testid={`retiros-sub-${k}`} onClick={() => setSub(k)}
              className={`h-9 px-4 rounded-full text-sm font-medium flex items-center gap-1.5 transition-colors ${sub === k ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>
              <Icon className="w-3.5 h-3.5" /> {l}
            </button>
          ))}
        </div>
      )}
      {sub === "mercancia" && canViewMerch && <WithdrawalsTab canConfirm={canConfirmMerch} />}
      {sub === "dinero" && canViewCash && <PaymentsAdminTab canConfirm={canConfirmCash} />}
    </div>
  );
}
